import { useMatches } from 'react-router-dom';

import { type PathwayScreen, pathwayScreens } from './use-config-api';

export const usePathwayScreen = () => {
    const matchIds = useMatches().map((match) => match.id);

    return matchIds.find((id) =>
        (pathwayScreens as readonly string[]).includes(id)
    ) as PathwayScreen | undefined;
};
